import { inject, getCurrentInstance, computed } from 'vue'
import { formContextKey, FormItemRule } from '../Form'
import { castArray } from 'lodash-es'
import formItemValidateTrigger from './FormItemValidateTrigger'

const useFormContext = () => {
  return inject(formContextKey)
}

const useFormItemSpan = () => {
  const formContext = useFormContext()!
  const { props } = getCurrentInstance()!

  return computed(() => (props.span ? (props.span as number) : formContext.itemSpan))
}

const useFormItemRules = () => {
  const formContext = useFormContext()!
  const { props, type } = getCurrentInstance()!
  const { name, label, required } = props
  let trigger = formItemValidateTrigger[type.name!]
  if (!trigger) {
    trigger = 'change'
  }

  return computed(() => {
    const rules: FormItemRule[] = []
    let flag = true

    if (required) {
      if (props.rules) {
        rules.push(...castArray(props.rules))
        flag = !rules.some((rule) => Object.keys(rule).includes('required'))
      }
      if (formContext.rules && formContext.rules[name as string]) {
        const formRules = castArray(formContext.rules[name as string])
        flag = !formRules.some((rule) => Object.keys(rule).includes('required'))
      }
    }

    if (flag) {
      rules.push({
        required: true,
        message: `必填项[${label ? label : name}]不能为空`,
        trigger: trigger,
      })
    }

    return rules
  })
}

const useFormItemDisabled = () => {
  const formContext = useFormContext()!
  const { props } = getCurrentInstance()!
  return computed(() => formContext.disabled || (props.disabled as boolean))
}

const useFormItemModel = () => {
  const formContext = useFormContext()!
  const { props } = getCurrentInstance()!
  const { name } = props

  return computed<any>({
    get: () => {
      return formContext.modelValue[name as string]
    },
    set: (newValue) => {
      formContext.updateModelValue(name as string, newValue)
    },
  })
}

export { useFormContext, useFormItemSpan, useFormItemRules, useFormItemDisabled, useFormItemModel }
